import { InventoryConfig, IssueConfig } from './aptConfig'
import { IdentifiableObject } from './types'
import { Message } from './message'
import type { DamageDetail, FinalMoveOutStatus, InspectionDetail } from '../containers/MoveOut/types'

export interface Issue extends IdentifiableObject {
    issue_config?: IssueConfig
    message: Message
    description?: string
}

export interface InventoryInspection extends IdentifiableObject {
    area: number
    area_inspection: number
    channel: null | number
    handled: boolean
    inventory: null
    inventory_config: number
    issue: Issue[]
    issue_config_options: IssueConfig[]
    message_count: number
    note: string
    status: null | number
    status_group: number
    unread_count: number
}

export interface AreaInspection extends IdentifiableObject {
    area_inspection_type: string
    status: string
    due_date?: string
}

export interface TenantMoveInInspection extends AreaInspection {
    inventory_configs: InventoryConfig[]
    inventory_inspection: InventoryInspection[]
}

export const AreaInspectionStatuses = {
    COMPLETE: 'COMPLETE',
}

export type HubMoveInState = 'not_available' | 'action_required' | 'complete'
export type HubMoveOutState = 'not_available' | 'pending' | 'processing' | 'complete'

export interface MoveInAreaSummary {
    area_label: string
    unit_name: string
    status: string
    due_date: string | null
}

export interface PropertyInspectionAreaSummary {
    area_label: string
    unit_name: string
}

export interface PropertyInspectionUpcoming {
    inspection_id: number
    name: string
    inspection_type_name: string
    start_date: string
    end_date: string
    areas: PropertyInspectionAreaSummary[]
}

export interface PropertyInspectionComplete {
    inspection_id: number
    name: string
    inspection_type_name: string
    start_date: string
    end_date: string
    completed_date: string | null
    detail: InspectionDetail[]
}

export interface TenantInspectionHubMoveIn {
    state: HubMoveInState
    survey_pending?: boolean
    areas: MoveInAreaSummary[]
    detail: InspectionDetail[]
}

export interface TenantInspectionHubPropertyInspections {
    upcoming: PropertyInspectionUpcoming[]
    complete: PropertyInspectionComplete[]
}

export interface TenantInspectionHubMoveOut {
    state: HubMoveOutState
    final_move_out_status: FinalMoveOutStatus | null
    fmo_available: boolean
    detail: InspectionDetail[]
    damages: DamageDetail[]
    total_damages: string
}

export interface TenantInspectionHubResponse {
    move_in: TenantInspectionHubMoveIn
    property_inspections: TenantInspectionHubPropertyInspections
    move_out: TenantInspectionHubMoveOut
}
